import React, { Component } from 'react';
import PropTypes from 'prop-types';

import backgroundIcon from 'components/Icons/backgroundIcon.png';
import grey from '@material-ui/core/colors/grey';
import Typography from '@material-ui/core/Typography';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    container: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    opacity: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      background: `url(${backgroundIcon})`,
      backgroundSize: theme.spacing(100),
      backgroundPositionX: theme.spacing(-8),
      width: '100%',
      opacity: 0.22,
    },
    content: {
      position: 'relative',
      width: '100%',
      marginTop: -theme.spacing(10),
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
    header: {
      width: '100%',
      fontSize: 50.9,
      letterSpacing: 'normal',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      marginLeft: theme.spacing(5),
      maxWidth: 360,
      color: grey[50],
      lineHeight: '1.46429em',
      [theme.breakpoints.down('md')]: {
        fontSize: 40,
        maxWidth: 280,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 26,
        maxWidth: 190,
      },
    },
    subheader: {
      fontSize: 19,
      fontWeight: 400,
      lineHeight: 1.41,
      letterSpacing: 0.2,
      color: grey[50],
      maxWidth: 320,
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(5),
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
        maxWidth: 270,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
        maxWidth: 200,
      },
    },
  };
};

class SplitPageLeft extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.opacity} />
        <div className={classes.content}>
          <Typography className={classes.header}>We're so happy to have you here</Typography>
          <Typography className={classes.subheader} variant="h1">
            Sift's people platform is engineered to bring out the best in you and your teams.
          </Typography>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(SplitPageLeft);
